import React from 'react';
import {Link} from "react-router";

function MarkdownLink({href, children, style}) {
    return (
        <Link to={href} style={style}>
            {children[0]}
        </Link>
    );
}

export default MarkdownLink;
